import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { DiretorioEmpresas } from '@/components/marketplace/DiretorioEmpresas';

export default function ConsumerHome() {
  const { t } = useTranslation();
  return (
    <ConsumerLayout>
      <Link
        to="/app/pedidos/novo"
        className="block rounded-lg border border-primary/40 bg-primary/5 px-4 py-3 mb-4 text-sm font-medium text-primary"
      >
        {t('requests.ctaHome')}
      </Link>
      <DiretorioEmpresas />
    </ConsumerLayout>
  );
}
